import { createFileRoute } from '@tanstack/react-router'
import { InvestorLayout } from '../../../../components/investor-layout'
import { useInvestorContext } from '../../../../contexts/investor-guard'

export const Route = createFileRoute('/app/investor/$id/wallet')({
  component: WalletPage,
})

function WalletPage() {
  const { creditBalance } = useInvestorContext()

  return (
    <InvestorLayout activeNav="">
      <div className="mx-auto max-w-3xl space-y-8 py-2">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight text-foreground">Wallet</h1>
          <p className="mt-1 text-sm text-muted-foreground">Your credits.</p>
        </div>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">Credits</h2>
          <div className="rounded-xl border border-border bg-card p-5">
            <p className="text-sm font-medium text-foreground">
              {creditBalance === undefined ? 'Loading…' : `${creditBalance} credits available`}
            </p>
            <p className="mt-1 text-sm text-muted-foreground">
              Searching, reading and following do not use credits.
            </p>
          </div>
        </section>
      </div>
    </InvestorLayout>
  )
}
